import React from 'react';
import {useStateContext} from "../../contexts/ContextProvider.jsx";


const Permission = (props) => {
  const { permissions } = useStateContext();

  const checkPermissions = () => {
    if (!permissions || !Array.isArray(permissions)) {
      return false;
    }

    if (Array.isArray(props.required)) {
      return props.required.some((p) => permissions.includes(p));
    }

    if (typeof props.required === 'string' && props.required.includes('|')) {
      return props.required.split('|').some((p) => permissions.includes(p.trim()));
    }

    return permissions.includes(props.required);
  };

  if (!props.required) {
    return props.children;
  }
  return (
    <>
      {checkPermissions() ? props.children : null}
    </>
  );
};

export default Permission;
